var _style, _polygon, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconYen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x32_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#27CDCB;}\r\n")), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "324.08,182.76 365.09,118.89 358.83,118.89 317.93,118.89 311.67,118.89 255.96,205.51 200.33,118.89 194.04,118.89 153.15,118.89 146.86,118.89 187.9,182.76 138.53,182.76 138.53,192.49 138.53,222.04 138.53,231.77 219.47,231.77 228.16,245.35 228.16,277.69 138.53,277.69 138.53,277.8 138.53,319.78 138.53,326.36 228.16,326.36 228.16,393.11 283.84,393.11 283.84,326.36 373.47,326.36 373.47,319.78 373.47,277.8 373.47,277.69 283.84,277.69 283.84,245.28 292.53,231.77 373.47,231.77 373.47,222.04 373.47,192.49 373.47,182.76 "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M256,0C114.63,0,0,114.62,0,256s114.63,256,256,256s256-114.63,256-256S397.38,0,256,0z M256,472 c-119.09,0-216-96.91-216-216S136.91,40,256,40s216,96.91,216,216S375.09,472,256,472z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconYen);
export default __webpack_public_path__ + "static/media/icon-yen.6fa6b90c7d3ddfef24d6e26beaa70619.svg";
export { ForwardRef as ReactComponent };